import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    dialog: {},
    header: {
      padding: "8px 16px 6px",
      maxWidth: 300
    },
    content: {
      overflow: "hidden",
      maxWidth: 300,
      padding: "8px 16px 8px"
    },
    title: {
      fontSize: 20,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    description: {
      fontSize: 14,
      color: primary.dark,
      marginBottom: 12
    },
    itemTitle: {
      fontSize: 12,
      color: primary.dark,
      lineHeight: "normal",
      marginBottom: 4
    },
    itemValue: {
      fontSize: 14,
      color: primary.main,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      lineHeight: "normal",
      marginBottom: 10
    },
    actions: {
      marginRight: 8
    },
    buttonClose: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 16,
      color: primary.dark
    },
    buttonConfirm: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 16,
      color: secondary.dark
    }
  };
});
